import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { SideBarContent } from "../../components/layouts/SideBarContent";
import useTranslation from "../../components/CustomHooks/useTranslation";

export default function Dashboard() {
  const navigate = useNavigate();
  const { translate } = useTranslation(SideBarContent);

  useEffect(() => {
    navigate("/dashboard");
  }, []);

  return (
    <motion.div
      className="flex items-center justify-center h-full w-full text-[100px]"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      {translate('Dashboard')}
    </motion.div>
  );
}
